import React, { useState } from 'react';
import styles from './styles.module.scss';

import { ReactComponent as ArrowDown } from '../../../assets/icons/icon-arrow-down.svg';
import { spanish } from '../../../config/config';

const Selector = ({
  id,
  title,
  placeholder,
  options,
  linkTypeOptions,
  languageOptions,
  monthOptions,
  levelOptions,
  dateRangeOptions,
  countriesWithBusiness,
  suburbs,
  required,
  onChange,
  disabled,
  width,
  value,
  fiscalRegimeOptions,
  cfdiOptions,
}) => {
  const errorMessage = spanish
    ? 'Este campo es requerido'
    : 'This field is required';
  const [error, setError] = useState(false);
  const validateInput = (e) => {
    if (required && e.currentTarget.value === '') setError(true);
    else setError(false);
  };
  let containerStyle = styles.full;
  if (width === 50) {
    containerStyle = styles.half;
  } else if (width === 30) {
    containerStyle = styles.third;
  }
  return (
    <div className={containerStyle}>
      {title !== undefined ? <p className={styles.title}>{title}</p> : ''}
      <label>
        <select
          id={id}
          className={error ? 'error' : ''}
          required={required}
          onChange={onChange}
          disabled={disabled}
          onBlur={validateInput}
          value={value}
        >
          {!disabled && <option value="">{placeholder}</option>}
          {options?.map((option) => (
            <option value={option} key={option}>
              {option}
            </option>
          ))}
          {languageOptions?.map((option) => (
            <option value={option.IdLanguage} key={option.IdLanguage}>
              {option.Language}
            </option>
          ))}
          {linkTypeOptions?.map((option) => (
            <option value={option.IdLinkType} key={option.IdLinkType}>
              {option.Description}
            </option>
          ))}
          {monthOptions?.map((option) => (
            <option value={option.monthId} key={option.monthId}>
              {option.monthName}
            </option>
          ))}
          {levelOptions?.map((option) => (
            <option value={option.value} key={option.id}>
              {option.labelName}
            </option>
          ))}
          {dateRangeOptions?.map((option) => (
            <option value={option.value} key={option.id}>
              {option.labelName}
            </option>
          ))}
          {countriesWithBusiness?.map((option) => (
            <option value={option.Abrev} key={option.Id}>
              {option.Pais}
            </option>
          ))}
          {suburbs?.map((option) => (
            <option value={option.IdColonia} key={option.IdColonia}>
              {option.Colonia}
            </option>
          ))}
          {fiscalRegimeOptions?.map((option) => (
            <option value={option.IdRegimen} key={option.IdRegimen}>
              {`${option.CodigoSAT} - ${option.Descripcion}`}
            </option>
          ))}
          {cfdiOptions?.map((option) => (
            <option value={option.idUsoCFDI} key={option.idUsoCFDI}>
              {`${option.claveCFDI} - ${option.descripcion}`}
            </option>
          ))}
        </select>
      </label>
      <ArrowDown />
      <p className={styles.error}>{error ? errorMessage : ''}</p>
    </div>
  );
};

export default Selector;
